import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-sales-process.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Sales Process";

const SalesProcess = () => (
  <div className="bg-gradient-to-b from-white to-gray-100">
    <HeroSection title={title} className="flex-col-reverse md:flex-row-reverse">
      <HeroSection.Content className="md:w-1/2 lg:w-5/12">
        <HeroSection.Header className="md:items-start">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          Enerflo Sales Core gives reps the most unified solar sales process in the industry. One platform, one login,
          one seamless experience, start to finish.
        </HeroSection.Description>
        <HeroSection.Action className="btn-navy" href="/features/sales-process">
          See it in Action
        </HeroSection.Action>
      </HeroSection.Content>

      <figure className="flex-grow w-full md:w-1/2 lg:w-7/12">
        <Image
          src={FigureImage}
          alt="Enerflo Solar Software Platform Sales Process."
          layout="responsive"
          quality={100}
          placeholder="blur"
          className="crispImage"
          sizes="(min-width: 768px) 60vw, 100vw"
          lazyBoundary="400px"
        />
      </figure>
    </HeroSection>
  </div>
);

export default SalesProcess;
